<template>
    <div>
        <Row  class="fault-title">
            <Col span="8">
                {{$t('l.fault_name')}}
            </Col>
            <Col span="8" class="center">
                {{$t('l.state_display')}}
            </Col>
            <Col span="8" class="center">
                {{$t('l.state_para')}}
            </Col>
        </Row>
        <template  v-for="(param, key) in parameterMap">
            <Row class="fault-item">
                <template v-if="key == 'fault_no'||key == 'floor_current'||key == 'running_speed'">
                    <Col span="8">
                        {{parameterMap[key]}}
                    </Col>
                    <Col span="8" class="center">
                        <span>{{params.hasOwnProperty(key)?params[key]:'--'}}</span>
                    </Col>
                    <Col span="8" class="center">
                        <span>{{params.hasOwnProperty(key)?params[key]:'--'}}</span>
                    </Col>
                </template>
                <!--run_status 检修 自动 -->
                <template v-else-if="key == 'run_status'">
                    <Col span="8">
                        {{parameterMap[key]}}
                    </Col>
                    <Col span="8" class="center">
                        <span>{{params.hasOwnProperty(key)?params[key]==1?$t('l.auto'):params[key]==2?$t('l.repair'):$t('l.other'):'--'}}</span>
                    </Col>
                    <Col span="8" class="center">
                        <span>{{params.hasOwnProperty(key)?params[key]:'--'}}</span>
                    </Col>
                </template>
                <template v-else>
                    <Col span="8">
                        {{parameterMap[key]}}
                    </Col>
                    <Col span="8" class="center">
                        <span v-if="params.hasOwnProperty(key)" :class="'detail-bg-'+params[key]"></span>
                        <span v-else>--</span>
                    </Col>
                    <Col span="8" class="center">
                        <span v-if="params.hasOwnProperty(key)">{{params[key]}}</span>
                        <span v-else>--</span>
                    </Col>
                </template>
            </Row>
        </template>
    </div>

</template>

<script>
    import parameterMap from "../../../constant-data/parameter-config"
    export default {
        name: "fault-detail",
        props:{
            params:{
                type:Object
            }
        },
        data(){
            return{
                parameterMap:parameterMap
            }
        }
    }
</script>

<style scoped lang="less">
    .fault-title{
        font-size: 14px;
        font-weight: 600;
    }
    .fault-item{
        margin:20px 0;
        font-size: 14px;
        border-bottom: 1px solid #000000;
    }
    .detail-bg-1,.detail-bg-0{
        width: 20px;
        height: 20px;
        display: inline-block;
        border-radius: 50%;
        opacity: 0.8;
    }
    .detail-bg-1{
        background-image: linear-gradient(#2ecc71,#33d9b2);
    }
    .detail-bg-0{
        background-image: linear-gradient(#d1ccc0,#aaa69d);
    }
    .center{
        display: flex;
        justify-content: center;
    }
</style>